/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as ClustersRouteImport } from './routes/clusters'
import { Route as DesignRouteImport } from './routes/design'
import { Route as DirectoryRouteImport } from './routes/directory'
import { Route as FlowsRouteImport } from './routes/flows'
import { Route as GraphRouteImport } from './routes/graph'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MapRouteImport } from './routes/map'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as RequestAccessRouteImport } from './routes/request-access'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as TimelineRouteImport } from './routes/timeline'
import { Route as UploadRouteImport } from './routes/upload'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAiRouteImport } from './routes/admin.ai'
import { Route as AdminApiKeysRouteImport } from './routes/admin.api-keys'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as AdminBackupsRouteImport } from './routes/admin.backups'
import { Route as AdminColorsRouteImport } from './routes/admin.colors'
import { Route as AdminErasuresRouteImport } from './routes/admin.erasures'
import { Route as AdminExportsRouteImport } from './routes/admin.exports'
import { Route as AdminHelpRouteImport } from './routes/admin.help'
import { Route as AdminListsRouteImport } from './routes/admin.lists'
import { Route as AdminMatchingRouteImport } from './routes/admin.matching'
import { Route as AdminMonitoringRouteImport } from './routes/admin.monitoring'
import { Route as AdminOutletsRouteImport } from './routes/admin.outlets'
import { Route as AdminQualityRouteImport } from './routes/admin.quality'
import { Route as AdminRelationsRouteImport } from './routes/admin.relations'
import { Route as AdminReportGatesRouteImport } from './routes/admin.report-gates'
import { Route as AdminReportTemplatesRouteImport } from './routes/admin.report-templates'
import { Route as AdminSchemaRouteImport } from './routes/admin.schema'
import { Route as AdminSearchRouteImport } from './routes/admin.search'
import { Route as AdminSocialRouteImport } from './routes/admin.social'
import { Route as AdminSourcesRouteImport } from './routes/admin.sources'
import { Route as AdminTemplatesRouteImport } from './routes/admin.templates'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as CasesIndexRouteImport } from './routes/cases.index'
import { Route as CasesIdRouteImport } from './routes/cases.$id'
import { Route as DatasetsIndexRouteImport } from './routes/datasets.index'
import { Route as DatasetsIdRouteImport } from './routes/datasets.$id'
import { Route as EntityIdRouteImport } from './routes/entity.$id'
import { Route as EntityNewRouteImport } from './routes/entity.new'
import { Route as FindingsIdRouteImport } from './routes/findings.$id'
import { Route as LibraryIndexRouteImport } from './routes/library.index'
import { Route as LibraryIdRouteImport } from './routes/library.$id'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding.index'
import { Route as OnboardingSlugRouteImport } from './routes/onboarding.$slug'
import { Route as ReportsIndexRouteImport } from './routes/reports.index'
import { Route as ReportsIdRouteImport } from './routes/reports.$id'
import { Route as ReportsNewRouteImport } from './routes/reports.new'
import { Route as ReviewIndexRouteImport } from './routes/review.index'
import { Route as ReviewIdRouteImport } from './routes/review.$id'
import { Route as SheetsIndexRouteImport } from './routes/sheets.index'
import { Route as SheetsIdRouteImport } from './routes/sheets.$id'
import { Route as AdminRegistersIndexRouteImport } from './routes/admin.registers.index'
import { Route as AdminRegistersIdRouteImport } from './routes/admin.registers.$id'
import { Route as AdminScrapersIndexRouteImport } from './routes/admin.scrapers.index'
import { Route as AdminScrapersIdRouteImport } from './routes/admin.scrapers.$id'
import { Route as ReviewBatchBatchIdRouteImport } from './routes/review.batch.$batchId'
import { Route as ReviewUnreviewedIdRouteImport } from './routes/review.unreviewed.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityRoute = ActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const ClustersRoute = ClustersRouteImport.update({
  id: '/clusters',
  path: '/clusters',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignRoute = DesignRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => rootRouteImport,
} as any)
const DirectoryRoute = DirectoryRouteImport.update({
  id: '/directory',
  path: '/directory',
  getParentRoute: () => rootRouteImport,
} as any)
const FlowsRoute = FlowsRouteImport.update({
  id: '/flows',
  path: '/flows',
  getParentRoute: () => rootRouteImport,
} as any)
const GraphRoute = GraphRouteImport.update({
  id: '/graph',
  path: '/graph',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MapRoute = MapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const RequestAccessRoute = RequestAccessRouteImport.update({
  id: '/request-access',
  path: '/request-access',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const TimelineRoute = TimelineRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => rootRouteImport,
} as any)
const UploadRoute = UploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAiRoute = AdminAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AdminRoute,
} as any)
const AdminApiKeysRoute = AdminApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBackupsRoute = AdminBackupsRouteImport.update({
  id: '/backups',
  path: '/backups',
  getParentRoute: () => AdminRoute,
} as any)
const AdminColorsRoute = AdminColorsRouteImport.update({
  id: '/colors',
  path: '/colors',
  getParentRoute: () => AdminRoute,
} as any)
const AdminErasuresRoute = AdminErasuresRouteImport.update({
  id: '/erasures',
  path: '/erasures',
  getParentRoute: () => AdminRoute,
} as any)
const AdminExportsRoute = AdminExportsRouteImport.update({
  id: '/exports',
  path: '/exports',
  getParentRoute: () => AdminRoute,
} as any)
const AdminHelpRoute = AdminHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AdminRoute,
} as any)
const AdminListsRoute = AdminListsRouteImport.update({
  id: '/lists',
  path: '/lists',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMatchingRoute = AdminMatchingRouteImport.update({
  id: '/matching',
  path: '/matching',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMonitoringRoute = AdminMonitoringRouteImport.update({
  id: '/monitoring',
  path: '/monitoring',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOutletsRoute = AdminOutletsRouteImport.update({
  id: '/outlets',
  path: '/outlets',
  getParentRoute: () => AdminRoute,
} as any)
const AdminQualityRoute = AdminQualityRouteImport.update({
  id: '/quality',
  path: '/quality',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRelationsRoute = AdminRelationsRouteImport.update({
  id: '/relations',
  path: '/relations',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReportGatesRoute = AdminReportGatesRouteImport.update({
  id: '/report-gates',
  path: '/report-gates',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReportTemplatesRoute = AdminReportTemplatesRouteImport.update({
  id: '/report-templates',
  path: '/report-templates',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSchemaRoute = AdminSchemaRouteImport.update({
  id: '/schema',
  path: '/schema',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSearchRoute = AdminSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSocialRoute = AdminSocialRouteImport.update({
  id: '/social',
  path: '/social',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSourcesRoute = AdminSourcesRouteImport.update({
  id: '/sources',
  path: '/sources',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTemplatesRoute = AdminTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const CasesIndexRoute = CasesIndexRouteImport.update({
  id: '/cases/',
  path: '/cases/',
  getParentRoute: () => rootRouteImport,
} as any)
const CasesIdRoute = CasesIdRouteImport.update({
  id: '/cases/$id',
  path: '/cases/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DatasetsIndexRoute = DatasetsIndexRouteImport.update({
  id: '/datasets/',
  path: '/datasets/',
  getParentRoute: () => rootRouteImport,
} as any)
const DatasetsIdRoute = DatasetsIdRouteImport.update({
  id: '/datasets/$id',
  path: '/datasets/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const EntityIdRoute = EntityIdRouteImport.update({
  id: '/entity/$id',
  path: '/entity/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const EntityNewRoute = EntityNewRouteImport.update({
  id: '/entity/new',
  path: '/entity/new',
  getParentRoute: () => rootRouteImport,
} as any)
const FindingsIdRoute = FindingsIdRouteImport.update({
  id: '/findings/$id',
  path: '/findings/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryIndexRoute = LibraryIndexRouteImport.update({
  id: '/library/',
  path: '/library/',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryIdRoute = LibraryIdRouteImport.update({
  id: '/library/$id',
  path: '/library/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingSlugRoute = OnboardingSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => OnboardingRoute,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsIdRoute = ReportsIdRouteImport.update({
  id: '/reports/$id',
  path: '/reports/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsNewRoute = ReportsNewRouteImport.update({
  id: '/reports/new',
  path: '/reports/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewIndexRoute = ReviewIndexRouteImport.update({
  id: '/review/',
  path: '/review/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewIdRoute = ReviewIdRouteImport.update({
  id: '/review/$id',
  path: '/review/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SheetsIndexRoute = SheetsIndexRouteImport.update({
  id: '/sheets/',
  path: '/sheets/',
  getParentRoute: () => rootRouteImport,
} as any)
const SheetsIdRoute = SheetsIdRouteImport.update({
  id: '/sheets/$id',
  path: '/sheets/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRegistersIndexRoute = AdminRegistersIndexRouteImport.update({
  id: '/registers/',
  path: '/registers/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRegistersIdRoute = AdminRegistersIdRouteImport.update({
  id: '/registers/$id',
  path: '/registers/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminScrapersIndexRoute = AdminScrapersIndexRouteImport.update({
  id: '/scrapers/',
  path: '/scrapers/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminScrapersIdRoute = AdminScrapersIdRouteImport.update({
  id: '/scrapers/$id',
  path: '/scrapers/$id',
  getParentRoute: () => AdminRoute,
} as any)
const ReviewBatchBatchIdRoute = ReviewBatchBatchIdRouteImport.update({
  id: '/review/batch/$batchId',
  path: '/review/batch/$batchId',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewUnreviewedIdRoute = ReviewUnreviewedIdRouteImport.update({
  id: '/review/unreviewed/$id',
  path: '/review/unreviewed/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/admin': typeof AdminRouteWithChildren
  '/chat': typeof ChatRoute
  '/clusters': typeof ClustersRoute
  '/design': typeof DesignRoute
  '/directory': typeof DirectoryRoute
  '/flows': typeof FlowsRoute
  '/graph': typeof GraphRoute
  '/login': typeof LoginRoute
  '/map': typeof MapRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/request-access': typeof RequestAccessRoute
  '/set-password': typeof SetPasswordRoute
  '/timeline': typeof TimelineRoute
  '/upload': typeof UploadRoute
  '/admin/ai': typeof AdminAiRoute
  '/admin/api-keys': typeof AdminApiKeysRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/backups': typeof AdminBackupsRoute
  '/admin/colors': typeof AdminColorsRoute
  '/admin/erasures': typeof AdminErasuresRoute
  '/admin/exports': typeof AdminExportsRoute
  '/admin/help': typeof AdminHelpRoute
  '/admin/lists': typeof AdminListsRoute
  '/admin/matching': typeof AdminMatchingRoute
  '/admin/monitoring': typeof AdminMonitoringRoute
  '/admin/outlets': typeof AdminOutletsRoute
  '/admin/quality': typeof AdminQualityRoute
  '/admin/relations': typeof AdminRelationsRoute
  '/admin/report-gates': typeof AdminReportGatesRoute
  '/admin/report-templates': typeof AdminReportTemplatesRoute
  '/admin/schema': typeof AdminSchemaRoute
  '/admin/search': typeof AdminSearchRoute
  '/admin/social': typeof AdminSocialRoute
  '/admin/sources': typeof AdminSourcesRoute
  '/admin/templates': typeof AdminTemplatesRoute
  '/admin/users': typeof AdminUsersRoute
  '/cases/$id': typeof CasesIdRoute
  '/datasets/$id': typeof DatasetsIdRoute
  '/entity/$id': typeof EntityIdRoute
  '/entity/new': typeof EntityNewRoute
  '/findings/$id': typeof FindingsIdRoute
  '/library/$id': typeof LibraryIdRoute
  '/onboarding/$slug': typeof OnboardingSlugRoute
  '/reports/$id': typeof ReportsIdRoute
  '/reports/new': typeof ReportsNewRoute
  '/review/$id': typeof ReviewIdRoute
  '/sheets/$id': typeof SheetsIdRoute
  '/admin/': typeof AdminIndexRoute
  '/cases/': typeof CasesIndexRoute
  '/datasets/': typeof DatasetsIndexRoute
  '/library/': typeof LibraryIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/review/': typeof ReviewIndexRoute
  '/sheets/': typeof SheetsIndexRoute
  '/admin/registers/$id': typeof AdminRegistersIdRoute
  '/admin/scrapers/$id': typeof AdminScrapersIdRoute
  '/review/batch/$batchId': typeof ReviewBatchBatchIdRoute
  '/review/unreviewed/$id': typeof ReviewUnreviewedIdRoute
  '/admin/registers/': typeof AdminRegistersIndexRoute
  '/admin/scrapers/': typeof AdminScrapersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/chat': typeof ChatRoute
  '/clusters': typeof ClustersRoute
  '/design': typeof DesignRoute
  '/directory': typeof DirectoryRoute
  '/flows': typeof FlowsRoute
  '/graph': typeof GraphRoute
  '/login': typeof LoginRoute
  '/map': typeof MapRoute
  '/request-access': typeof RequestAccessRoute
  '/set-password': typeof SetPasswordRoute
  '/timeline': typeof TimelineRoute
  '/upload': typeof UploadRoute
  '/admin/ai': typeof AdminAiRoute
  '/admin/api-keys': typeof AdminApiKeysRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/backups': typeof AdminBackupsRoute
  '/admin/colors': typeof AdminColorsRoute
  '/admin/erasures': typeof AdminErasuresRoute
  '/admin/exports': typeof AdminExportsRoute
  '/admin/help': typeof AdminHelpRoute
  '/admin/lists': typeof AdminListsRoute
  '/admin/matching': typeof AdminMatchingRoute
  '/admin/monitoring': typeof AdminMonitoringRoute
  '/admin/outlets': typeof AdminOutletsRoute
  '/admin/quality': typeof AdminQualityRoute
  '/admin/relations': typeof AdminRelationsRoute
  '/admin/report-gates': typeof AdminReportGatesRoute
  '/admin/report-templates': typeof AdminReportTemplatesRoute
  '/admin/schema': typeof AdminSchemaRoute
  '/admin/search': typeof AdminSearchRoute
  '/admin/social': typeof AdminSocialRoute
  '/admin/sources': typeof AdminSourcesRoute
  '/admin/templates': typeof AdminTemplatesRoute
  '/admin/users': typeof AdminUsersRoute
  '/cases/$id': typeof CasesIdRoute
  '/datasets/$id': typeof DatasetsIdRoute
  '/entity/$id': typeof EntityIdRoute
  '/entity/new': typeof EntityNewRoute
  '/findings/$id': typeof FindingsIdRoute
  '/library/$id': typeof LibraryIdRoute
  '/onboarding/$slug': typeof OnboardingSlugRoute
  '/reports/$id': typeof ReportsIdRoute
  '/reports/new': typeof ReportsNewRoute
  '/review/$id': typeof ReviewIdRoute
  '/sheets/$id': typeof SheetsIdRoute
  '/admin': typeof AdminIndexRoute
  '/cases': typeof CasesIndexRoute
  '/datasets': typeof DatasetsIndexRoute
  '/library': typeof LibraryIndexRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/reports': typeof ReportsIndexRoute
  '/review': typeof ReviewIndexRoute
  '/sheets': typeof SheetsIndexRoute
  '/admin/registers/$id': typeof AdminRegistersIdRoute
  '/admin/scrapers/$id': typeof AdminScrapersIdRoute
  '/review/batch/$batchId': typeof ReviewBatchBatchIdRoute
  '/review/unreviewed/$id': typeof ReviewUnreviewedIdRoute
  '/admin/registers': typeof AdminRegistersIndexRoute
  '/admin/scrapers': typeof AdminScrapersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/admin': typeof AdminRouteWithChildren
  '/chat': typeof ChatRoute
  '/clusters': typeof ClustersRoute
  '/design': typeof DesignRoute
  '/directory': typeof DirectoryRoute
  '/flows': typeof FlowsRoute
  '/graph': typeof GraphRoute
  '/login': typeof LoginRoute
  '/map': typeof MapRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/request-access': typeof RequestAccessRoute
  '/set-password': typeof SetPasswordRoute
  '/timeline': typeof TimelineRoute
  '/upload': typeof UploadRoute
  '/admin/ai': typeof AdminAiRoute
  '/admin/api-keys': typeof AdminApiKeysRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/backups': typeof AdminBackupsRoute
  '/admin/colors': typeof AdminColorsRoute
  '/admin/erasures': typeof AdminErasuresRoute
  '/admin/exports': typeof AdminExportsRoute
  '/admin/help': typeof AdminHelpRoute
  '/admin/lists': typeof AdminListsRoute
  '/admin/matching': typeof AdminMatchingRoute
  '/admin/monitoring': typeof AdminMonitoringRoute
  '/admin/outlets': typeof AdminOutletsRoute
  '/admin/quality': typeof AdminQualityRoute
  '/admin/relations': typeof AdminRelationsRoute
  '/admin/report-gates': typeof AdminReportGatesRoute
  '/admin/report-templates': typeof AdminReportTemplatesRoute
  '/admin/schema': typeof AdminSchemaRoute
  '/admin/search': typeof AdminSearchRoute
  '/admin/social': typeof AdminSocialRoute
  '/admin/sources': typeof AdminSourcesRoute
  '/admin/templates': typeof AdminTemplatesRoute
  '/admin/users': typeof AdminUsersRoute
  '/cases/$id': typeof CasesIdRoute
  '/datasets/$id': typeof DatasetsIdRoute
  '/entity/$id': typeof EntityIdRoute
  '/entity/new': typeof EntityNewRoute
  '/findings/$id': typeof FindingsIdRoute
  '/library/$id': typeof LibraryIdRoute
  '/onboarding/$slug': typeof OnboardingSlugRoute
  '/reports/$id': typeof ReportsIdRoute
  '/reports/new': typeof ReportsNewRoute
  '/review/$id': typeof ReviewIdRoute
  '/sheets/$id': typeof SheetsIdRoute
  '/admin/': typeof AdminIndexRoute
  '/cases/': typeof CasesIndexRoute
  '/datasets/': typeof DatasetsIndexRoute
  '/library/': typeof LibraryIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/review/': typeof ReviewIndexRoute
  '/sheets/': typeof SheetsIndexRoute
  '/admin/registers/$id': typeof AdminRegistersIdRoute
  '/admin/scrapers/$id': typeof AdminScrapersIdRoute
  '/review/batch/$batchId': typeof ReviewBatchBatchIdRoute
  '/review/unreviewed/$id': typeof ReviewUnreviewedIdRoute
  '/admin/registers/': typeof AdminRegistersIndexRoute
  '/admin/scrapers/': typeof AdminScrapersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activity'
    | '/admin'
    | '/chat'
    | '/clusters'
    | '/design'
    | '/directory'
    | '/flows'
    | '/graph'
    | '/login'
    | '/map'
    | '/onboarding'
    | '/request-access'
    | '/set-password'
    | '/timeline'
    | '/upload'
    | '/admin/ai'
    | '/admin/api-keys'
    | '/admin/audit'
    | '/admin/backups'
    | '/admin/colors'
    | '/admin/erasures'
    | '/admin/exports'
    | '/admin/help'
    | '/admin/lists'
    | '/admin/matching'
    | '/admin/monitoring'
    | '/admin/outlets'
    | '/admin/quality'
    | '/admin/relations'
    | '/admin/report-gates'
    | '/admin/report-templates'
    | '/admin/schema'
    | '/admin/search'
    | '/admin/social'
    | '/admin/sources'
    | '/admin/templates'
    | '/admin/users'
    | '/cases/$id'
    | '/datasets/$id'
    | '/entity/$id'
    | '/entity/new'
    | '/findings/$id'
    | '/library/$id'
    | '/onboarding/$slug'
    | '/reports/$id'
    | '/reports/new'
    | '/review/$id'
    | '/sheets/$id'
    | '/admin/'
    | '/cases/'
    | '/datasets/'
    | '/library/'
    | '/onboarding/'
    | '/reports/'
    | '/review/'
    | '/sheets/'
    | '/admin/registers/$id'
    | '/admin/scrapers/$id'
    | '/review/batch/$batchId'
    | '/review/unreviewed/$id'
    | '/admin/registers/'
    | '/admin/scrapers/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activity'
    | '/chat'
    | '/clusters'
    | '/design'
    | '/directory'
    | '/flows'
    | '/graph'
    | '/login'
    | '/map'
    | '/request-access'
    | '/set-password'
    | '/timeline'
    | '/upload'
    | '/admin/ai'
    | '/admin/api-keys'
    | '/admin/audit'
    | '/admin/backups'
    | '/admin/colors'
    | '/admin/erasures'
    | '/admin/exports'
    | '/admin/help'
    | '/admin/lists'
    | '/admin/matching'
    | '/admin/monitoring'
    | '/admin/outlets'
    | '/admin/quality'
    | '/admin/relations'
    | '/admin/report-gates'
    | '/admin/report-templates'
    | '/admin/schema'
    | '/admin/search'
    | '/admin/social'
    | '/admin/sources'
    | '/admin/templates'
    | '/admin/users'
    | '/cases/$id'
    | '/datasets/$id'
    | '/entity/$id'
    | '/entity/new'
    | '/findings/$id'
    | '/library/$id'
    | '/onboarding/$slug'
    | '/reports/$id'
    | '/reports/new'
    | '/review/$id'
    | '/sheets/$id'
    | '/admin'
    | '/cases'
    | '/datasets'
    | '/library'
    | '/onboarding'
    | '/reports'
    | '/review'
    | '/sheets'
    | '/admin/registers/$id'
    | '/admin/scrapers/$id'
    | '/review/batch/$batchId'
    | '/review/unreviewed/$id'
    | '/admin/registers'
    | '/admin/scrapers'
  id:
    | '__root__'
    | '/'
    | '/activity'
    | '/admin'
    | '/chat'
    | '/clusters'
    | '/design'
    | '/directory'
    | '/flows'
    | '/graph'
    | '/login'
    | '/map'
    | '/onboarding'
    | '/request-access'
    | '/set-password'
    | '/timeline'
    | '/upload'
    | '/admin/ai'
    | '/admin/api-keys'
    | '/admin/audit'
    | '/admin/backups'
    | '/admin/colors'
    | '/admin/erasures'
    | '/admin/exports'
    | '/admin/help'
    | '/admin/lists'
    | '/admin/matching'
    | '/admin/monitoring'
    | '/admin/outlets'
    | '/admin/quality'
    | '/admin/relations'
    | '/admin/report-gates'
    | '/admin/report-templates'
    | '/admin/schema'
    | '/admin/search'
    | '/admin/social'
    | '/admin/sources'
    | '/admin/templates'
    | '/admin/users'
    | '/cases/$id'
    | '/datasets/$id'
    | '/entity/$id'
    | '/entity/new'
    | '/findings/$id'
    | '/library/$id'
    | '/onboarding/$slug'
    | '/reports/$id'
    | '/reports/new'
    | '/review/$id'
    | '/sheets/$id'
    | '/admin/'
    | '/cases/'
    | '/datasets/'
    | '/library/'
    | '/onboarding/'
    | '/reports/'
    | '/review/'
    | '/sheets/'
    | '/admin/registers/$id'
    | '/admin/scrapers/$id'
    | '/review/batch/$batchId'
    | '/review/unreviewed/$id'
    | '/admin/registers/'
    | '/admin/scrapers/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivityRoute: typeof ActivityRoute
  AdminRoute: typeof AdminRouteWithChildren
  ChatRoute: typeof ChatRoute
  ClustersRoute: typeof ClustersRoute
  DesignRoute: typeof DesignRoute
  DirectoryRoute: typeof DirectoryRoute
  FlowsRoute: typeof FlowsRoute
  GraphRoute: typeof GraphRoute
  LoginRoute: typeof LoginRoute
  MapRoute: typeof MapRoute
  OnboardingRoute: typeof OnboardingRouteWithChildren
  RequestAccessRoute: typeof RequestAccessRoute
  SetPasswordRoute: typeof SetPasswordRoute
  TimelineRoute: typeof TimelineRoute
  UploadRoute: typeof UploadRoute
  CasesIdRoute: typeof CasesIdRoute
  DatasetsIdRoute: typeof DatasetsIdRoute
  EntityIdRoute: typeof EntityIdRoute
  EntityNewRoute: typeof EntityNewRoute
  FindingsIdRoute: typeof FindingsIdRoute
  LibraryIdRoute: typeof LibraryIdRoute
  ReportsIdRoute: typeof ReportsIdRoute
  ReportsNewRoute: typeof ReportsNewRoute
  ReviewIdRoute: typeof ReviewIdRoute
  SheetsIdRoute: typeof SheetsIdRoute
  CasesIndexRoute: typeof CasesIndexRoute
  DatasetsIndexRoute: typeof DatasetsIndexRoute
  LibraryIndexRoute: typeof LibraryIndexRoute
  ReportsIndexRoute: typeof ReportsIndexRoute
  ReviewIndexRoute: typeof ReviewIndexRoute
  SheetsIndexRoute: typeof SheetsIndexRoute
  ReviewBatchBatchIdRoute: typeof ReviewBatchBatchIdRoute
  ReviewUnreviewedIdRoute: typeof ReviewUnreviewedIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity': {
      id: '/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clusters': {
      id: '/clusters'
      path: '/clusters'
      fullPath: '/clusters'
      preLoaderRoute: typeof ClustersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design': {
      id: '/design'
      path: '/design'
      fullPath: '/design'
      preLoaderRoute: typeof DesignRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/directory': {
      id: '/directory'
      path: '/directory'
      fullPath: '/directory'
      preLoaderRoute: typeof DirectoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flows': {
      id: '/flows'
      path: '/flows'
      fullPath: '/flows'
      preLoaderRoute: typeof FlowsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/graph': {
      id: '/graph'
      path: '/graph'
      fullPath: '/graph'
      preLoaderRoute: typeof GraphRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/map': {
      id: '/map'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof MapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/request-access': {
      id: '/request-access'
      path: '/request-access'
      fullPath: '/request-access'
      preLoaderRoute: typeof RequestAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/timeline': {
      id: '/timeline'
      path: '/timeline'
      fullPath: '/timeline'
      preLoaderRoute: typeof TimelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upload': {
      id: '/upload'
      path: '/upload'
      fullPath: '/upload'
      preLoaderRoute: typeof UploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/ai': {
      id: '/admin/ai'
      path: '/ai'
      fullPath: '/admin/ai'
      preLoaderRoute: typeof AdminAiRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/api-keys': {
      id: '/admin/api-keys'
      path: '/api-keys'
      fullPath: '/admin/api-keys'
      preLoaderRoute: typeof AdminApiKeysRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/backups': {
      id: '/admin/backups'
      path: '/backups'
      fullPath: '/admin/backups'
      preLoaderRoute: typeof AdminBackupsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/colors': {
      id: '/admin/colors'
      path: '/colors'
      fullPath: '/admin/colors'
      preLoaderRoute: typeof AdminColorsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/erasures': {
      id: '/admin/erasures'
      path: '/erasures'
      fullPath: '/admin/erasures'
      preLoaderRoute: typeof AdminErasuresRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/exports': {
      id: '/admin/exports'
      path: '/exports'
      fullPath: '/admin/exports'
      preLoaderRoute: typeof AdminExportsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/help': {
      id: '/admin/help'
      path: '/help'
      fullPath: '/admin/help'
      preLoaderRoute: typeof AdminHelpRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/lists': {
      id: '/admin/lists'
      path: '/lists'
      fullPath: '/admin/lists'
      preLoaderRoute: typeof AdminListsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/matching': {
      id: '/admin/matching'
      path: '/matching'
      fullPath: '/admin/matching'
      preLoaderRoute: typeof AdminMatchingRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/monitoring': {
      id: '/admin/monitoring'
      path: '/monitoring'
      fullPath: '/admin/monitoring'
      preLoaderRoute: typeof AdminMonitoringRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/outlets': {
      id: '/admin/outlets'
      path: '/outlets'
      fullPath: '/admin/outlets'
      preLoaderRoute: typeof AdminOutletsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/quality': {
      id: '/admin/quality'
      path: '/quality'
      fullPath: '/admin/quality'
      preLoaderRoute: typeof AdminQualityRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/relations': {
      id: '/admin/relations'
      path: '/relations'
      fullPath: '/admin/relations'
      preLoaderRoute: typeof AdminRelationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/report-gates': {
      id: '/admin/report-gates'
      path: '/report-gates'
      fullPath: '/admin/report-gates'
      preLoaderRoute: typeof AdminReportGatesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/report-templates': {
      id: '/admin/report-templates'
      path: '/report-templates'
      fullPath: '/admin/report-templates'
      preLoaderRoute: typeof AdminReportTemplatesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/schema': {
      id: '/admin/schema'
      path: '/schema'
      fullPath: '/admin/schema'
      preLoaderRoute: typeof AdminSchemaRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/search': {
      id: '/admin/search'
      path: '/search'
      fullPath: '/admin/search'
      preLoaderRoute: typeof AdminSearchRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/social': {
      id: '/admin/social'
      path: '/social'
      fullPath: '/admin/social'
      preLoaderRoute: typeof AdminSocialRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/sources': {
      id: '/admin/sources'
      path: '/sources'
      fullPath: '/admin/sources'
      preLoaderRoute: typeof AdminSourcesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/templates': {
      id: '/admin/templates'
      path: '/templates'
      fullPath: '/admin/templates'
      preLoaderRoute: typeof AdminTemplatesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/cases/': {
      id: '/cases/'
      path: '/cases'
      fullPath: '/cases/'
      preLoaderRoute: typeof CasesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cases/$id': {
      id: '/cases/$id'
      path: '/cases/$id'
      fullPath: '/cases/$id'
      preLoaderRoute: typeof CasesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/datasets/': {
      id: '/datasets/'
      path: '/datasets'
      fullPath: '/datasets/'
      preLoaderRoute: typeof DatasetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/datasets/$id': {
      id: '/datasets/$id'
      path: '/datasets/$id'
      fullPath: '/datasets/$id'
      preLoaderRoute: typeof DatasetsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entity/$id': {
      id: '/entity/$id'
      path: '/entity/$id'
      fullPath: '/entity/$id'
      preLoaderRoute: typeof EntityIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entity/new': {
      id: '/entity/new'
      path: '/entity/new'
      fullPath: '/entity/new'
      preLoaderRoute: typeof EntityNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/findings/$id': {
      id: '/findings/$id'
      path: '/findings/$id'
      fullPath: '/findings/$id'
      preLoaderRoute: typeof FindingsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library/': {
      id: '/library/'
      path: '/library'
      fullPath: '/library/'
      preLoaderRoute: typeof LibraryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library/$id': {
      id: '/library/$id'
      path: '/library/$id'
      fullPath: '/library/$id'
      preLoaderRoute: typeof LibraryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/$slug': {
      id: '/onboarding/$slug'
      path: '/$slug'
      fullPath: '/onboarding/$slug'
      preLoaderRoute: typeof OnboardingSlugRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/reports/': {
      id: '/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/$id': {
      id: '/reports/$id'
      path: '/reports/$id'
      fullPath: '/reports/$id'
      preLoaderRoute: typeof ReportsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/new': {
      id: '/reports/new'
      path: '/reports/new'
      fullPath: '/reports/new'
      preLoaderRoute: typeof ReportsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review/': {
      id: '/review/'
      path: '/review'
      fullPath: '/review/'
      preLoaderRoute: typeof ReviewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review/$id': {
      id: '/review/$id'
      path: '/review/$id'
      fullPath: '/review/$id'
      preLoaderRoute: typeof ReviewIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sheets/': {
      id: '/sheets/'
      path: '/sheets'
      fullPath: '/sheets/'
      preLoaderRoute: typeof SheetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sheets/$id': {
      id: '/sheets/$id'
      path: '/sheets/$id'
      fullPath: '/sheets/$id'
      preLoaderRoute: typeof SheetsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/registers/': {
      id: '/admin/registers/'
      path: '/registers'
      fullPath: '/admin/registers/'
      preLoaderRoute: typeof AdminRegistersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/registers/$id': {
      id: '/admin/registers/$id'
      path: '/registers/$id'
      fullPath: '/admin/registers/$id'
      preLoaderRoute: typeof AdminRegistersIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/scrapers/': {
      id: '/admin/scrapers/'
      path: '/scrapers'
      fullPath: '/admin/scrapers/'
      preLoaderRoute: typeof AdminScrapersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/scrapers/$id': {
      id: '/admin/scrapers/$id'
      path: '/scrapers/$id'
      fullPath: '/admin/scrapers/$id'
      preLoaderRoute: typeof AdminScrapersIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/review/batch/$batchId': {
      id: '/review/batch/$batchId'
      path: '/review/batch/$batchId'
      fullPath: '/review/batch/$batchId'
      preLoaderRoute: typeof ReviewBatchBatchIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review/unreviewed/$id': {
      id: '/review/unreviewed/$id'
      path: '/review/unreviewed/$id'
      fullPath: '/review/unreviewed/$id'
      preLoaderRoute: typeof ReviewUnreviewedIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdminRouteChildren {
  AdminAiRoute: typeof AdminAiRoute
  AdminApiKeysRoute: typeof AdminApiKeysRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminBackupsRoute: typeof AdminBackupsRoute
  AdminColorsRoute: typeof AdminColorsRoute
  AdminErasuresRoute: typeof AdminErasuresRoute
  AdminExportsRoute: typeof AdminExportsRoute
  AdminHelpRoute: typeof AdminHelpRoute
  AdminListsRoute: typeof AdminListsRoute
  AdminMatchingRoute: typeof AdminMatchingRoute
  AdminMonitoringRoute: typeof AdminMonitoringRoute
  AdminOutletsRoute: typeof AdminOutletsRoute
  AdminQualityRoute: typeof AdminQualityRoute
  AdminRelationsRoute: typeof AdminRelationsRoute
  AdminReportGatesRoute: typeof AdminReportGatesRoute
  AdminReportTemplatesRoute: typeof AdminReportTemplatesRoute
  AdminSchemaRoute: typeof AdminSchemaRoute
  AdminSearchRoute: typeof AdminSearchRoute
  AdminSocialRoute: typeof AdminSocialRoute
  AdminSourcesRoute: typeof AdminSourcesRoute
  AdminTemplatesRoute: typeof AdminTemplatesRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminRegistersIdRoute: typeof AdminRegistersIdRoute
  AdminScrapersIdRoute: typeof AdminScrapersIdRoute
  AdminRegistersIndexRoute: typeof AdminRegistersIndexRoute
  AdminScrapersIndexRoute: typeof AdminScrapersIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAiRoute: AdminAiRoute,
  AdminApiKeysRoute: AdminApiKeysRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminBackupsRoute: AdminBackupsRoute,
  AdminColorsRoute: AdminColorsRoute,
  AdminErasuresRoute: AdminErasuresRoute,
  AdminExportsRoute: AdminExportsRoute,
  AdminHelpRoute: AdminHelpRoute,
  AdminListsRoute: AdminListsRoute,
  AdminMatchingRoute: AdminMatchingRoute,
  AdminMonitoringRoute: AdminMonitoringRoute,
  AdminOutletsRoute: AdminOutletsRoute,
  AdminQualityRoute: AdminQualityRoute,
  AdminRelationsRoute: AdminRelationsRoute,
  AdminReportGatesRoute: AdminReportGatesRoute,
  AdminReportTemplatesRoute: AdminReportTemplatesRoute,
  AdminSchemaRoute: AdminSchemaRoute,
  AdminSearchRoute: AdminSearchRoute,
  AdminSocialRoute: AdminSocialRoute,
  AdminSourcesRoute: AdminSourcesRoute,
  AdminTemplatesRoute: AdminTemplatesRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminRegistersIdRoute: AdminRegistersIdRoute,
  AdminScrapersIdRoute: AdminScrapersIdRoute,
  AdminRegistersIndexRoute: AdminRegistersIndexRoute,
  AdminScrapersIndexRoute: AdminScrapersIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface OnboardingRouteChildren {
  OnboardingSlugRoute: typeof OnboardingSlugRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingSlugRoute: OnboardingSlugRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivityRoute: ActivityRoute,
  AdminRoute: AdminRouteWithChildren,
  ChatRoute: ChatRoute,
  ClustersRoute: ClustersRoute,
  DesignRoute: DesignRoute,
  DirectoryRoute: DirectoryRoute,
  FlowsRoute: FlowsRoute,
  GraphRoute: GraphRoute,
  LoginRoute: LoginRoute,
  MapRoute: MapRoute,
  OnboardingRoute: OnboardingRouteWithChildren,
  RequestAccessRoute: RequestAccessRoute,
  SetPasswordRoute: SetPasswordRoute,
  TimelineRoute: TimelineRoute,
  UploadRoute: UploadRoute,
  CasesIdRoute: CasesIdRoute,
  DatasetsIdRoute: DatasetsIdRoute,
  EntityIdRoute: EntityIdRoute,
  EntityNewRoute: EntityNewRoute,
  FindingsIdRoute: FindingsIdRoute,
  LibraryIdRoute: LibraryIdRoute,
  ReportsIdRoute: ReportsIdRoute,
  ReportsNewRoute: ReportsNewRoute,
  ReviewIdRoute: ReviewIdRoute,
  SheetsIdRoute: SheetsIdRoute,
  CasesIndexRoute: CasesIndexRoute,
  DatasetsIndexRoute: DatasetsIndexRoute,
  LibraryIndexRoute: LibraryIndexRoute,
  ReportsIndexRoute: ReportsIndexRoute,
  ReviewIndexRoute: ReviewIndexRoute,
  SheetsIndexRoute: SheetsIndexRoute,
  ReviewBatchBatchIdRoute: ReviewBatchBatchIdRoute,
  ReviewUnreviewedIdRoute: ReviewUnreviewedIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
